<template>
  <div class="global-navi-header-container">
    <transition name="global-navi-overlay-fade">
      <div class="global-navi-overlay" @click="onSideMenuClose" v-if="showSideMenu"></div>
    </transition>
    <div class="global-navi-header-inner">

      <div class="global-navi-header">
        <div class="global-navi-title-label global-navi-logo">
          <service-logo><slot /></service-logo>
        </div>
        <div class="global-navi-beautyday-logo" v-if="showBeautydayButtonTerm1">
          <beautyday-button-term1 />
        </div>
        <div class="global-navi-beautyday-logo" v-if="showBeautydayButtonTerm2">
          <beautyday-button-term2 />
        </div>
        <div class="global-navi-beautyday-logo" v-if="showBeautydayButtonTerm3">
          <beautyday-button-term3 />
        </div>
        <div class="global-navi-beautyday-logo" v-if="showBeautydayButtonTerm4">
          <beautyday-button-term4 />
        </div>
        <div class="global-navi-header-navi-list">

          <ul class="global-navi-header-navi-list-items" v-if="$store.getters['context/ready']">
            <li class="global-navi-top-link-btn" v-if="showHomeButton">
              <home-button />
            </li>
            <li class="global-navi-search-btn" v-if="showSearchButton">
              <search-button @click="$emit('search-button-clicked')" />
            </li>
            <li class="global-navi-account-btn" v-if="viewerId && loginUrl">
              <my-button />
            </li>
            <li class="global-navi-login-btn" v-if="!viewerId && loginUrl">
              <login-button :login-url="loginUrl" />
            </li>
            <li class="global-navi-menu-btn" v-if="showMenuButton">
              <menu-button
                v-analytics="{label:'header_side_menu'}"
                @click="onSideMenuOpen"
              />
            </li>
          </ul>
        <!-- /global-navi-header-navi-list --></div>

        <transition name="bounce"
          v-if="showMenuButton"
          @after-enter="onSideMenuOpened"
          @after-leave="onSideMenuClosed">
          <side-menu
            ref="sideMenu"
            v-show="showSideMenu"
            @content-changed="onSideMenuContentChanged"
            :login-url="loginUrl"
            :active="showSideMenu"
          />
        </transition>

      <!-- /global-navi-header --></div>
    <!-- /global-navi-header-inner --></div>

    <div class="global-navi-header-info" v-if="showNaviInfo">
    <!-- /global-navi-header-info --></div>

  </div>
</template>

<script>
import ServiceLogo          from './global-header/service-logo';
import SearchButton         from './global-header/search-button';
import MyButton             from './global-header/my-button';
import LoginButton          from './global-header/login-button';
import HomeButton           from './global-header/home-button';
import MenuButton           from './global-header/menu-button';
import SideMenu             from './global-header/side-menu';
import BeautydayButtonTerm1 from './global-header/beautyday-button-term1';
import BeautydayButtonTerm2 from './global-header/beautyday-button-term2';
import BeautydayButtonTerm3 from './global-header/beautyday-button-term3';
import BeautydayButtonTerm4 from './global-header/beautyday-button-term4';
import analytics            from '../../directives/analytics';

export default {
  name      : 'global-header',
  directives: {
    analytics,
  },
  components: {
    ServiceLogo,
    SearchButton,
    MyButton,
    LoginButton,
    HomeButton,
    MenuButton,
    BeautydayButtonTerm1,
    BeautydayButtonTerm2,
    BeautydayButtonTerm3,
    BeautydayButtonTerm4,
    SideMenu,
  },
  props : {
    loginUrl: {
      type   : String,
      default: '',
    },
    showHomeButton: {
      type   : Boolean,
      default: false,
    },
    showSearchButton: {
      type   : Boolean,
      default: false,
    },
    hideMenuButton: {
      type   : Boolean,
      default: false,
    },
    showBeautydayButtonTerm1: {
      type   : Boolean,
      default: false,
    },
    showBeautydayButtonTerm2: {
      type   : Boolean,
      default: false,
    },
    showBeautydayButtonTerm3: {
      type   : Boolean,
      default: false,
    },
    showBeautydayButtonTerm4: {
      type   : Boolean,
      default: false,
    }
  },
  data: function() {
    return {
      showMenuButton: !this.hideMenuButton,
      showSideMenu  : false,
      showNaviInfo  : false,
    };
  },
  computed: {
    viewerId: function() {
      return this.$store.state.context.viewer.istyleId;
    },
  },
  methods: {
    getSideMenu: function() {
      return this.$refs.sideMenu;
    },
    onSideMenuContentChanged: function() {
      this.$emit('side-menu-content-changed', this.$refs.sideMenu);
    },
    onSideMenuOpen: function() {
      this.showSideMenu = true;
      this.$emit('side-menu-open', this.$refs.sideMenu);
    },
    onSideMenuOpened: function() {
      this.$emit('side-menu-opened', this.$refs.sideMenu);
    },
    onSideMenuClose: function() {
      this.showSideMenu = false;
      this.$emit('side-menu-close', this.$refs.sideMenu);
    },
    onSideMenuClosed: function() {
      this.$emit('side-menu-closed', this.$refs.sideMenu);
    },
  },
};
</script>

<style lang="scss">
@charset "utf-8";

// import
@import "~@istyle-inc/global-navigation/sass/sp/global_header";
</style>
